import * as React from "react";
import MaskedInput, { MaskedInputProps } from "./MaskedInput";

interface AccountInputProps extends Omit<MaskedInputProps, "mask" | "unmask"> {
  mask?: MaskedInputProps["mask"];
}

const AccountInput: React.FC<AccountInputProps> = ({ mask = "0000.00.00000", ...rest }) => {
  return <MaskedInput {...rest} placeholderChar="x" mask={mask} />;
};

export default AccountInput;
